<template>
	<div class="news">
		<div class="container news-bg">
			<div class="row nav-row">
				<div class="col-12">
					<router-link to='/news' @click.native="scrollToTop" class="back-link d-inline-block mb-5">← Wróć do listy artykułów</router-link>
				</div>
			</div>
			<div class="row content-row">
				<div class="col-12 col-lg-8 offset-lg-2">
					<vue-markdown :source="content"></vue-markdown>
				</div>
			</div>
		</div>
		<div class="container mt-5" v-if="recentEntry !== null">
				<div class="row">
					<div class="col-12 col-lg-8 offset-lg-2 pb-4">
						<h5 >
							Przeczytaj też
						</h5>
						<hr class="hr-black">
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-sm-6 offset-sm-2 offset-lg-0 col-lg-3 offset-lg-2">
						<div class="news-list__image" :style="{'background-image': 'url('+recentEntry.image+')'}"></div>
					</div>
					<div class="col-12 col-lg-5 d-flex align-items-start justify-content-center flex-column">
						<h6 class="text-gray">
							{{ recentEntry.date }}
						</h6>
						<h4>
							{{ recentEntry.title }}
						</h4>
						<router-link :to="'/news/'+recentEntry.slug" @click.native="scrollToTop" class="fw-500 text-gradient link-underline">Przeczytaj artykuł</router-link>
					</div>
				</div>
			</div>
	</div>
</template>


<script>
import axios from 'axios'
import VueMarkdown from 'vue-markdown'

export default { 
	data() {
		return{
			content: null,
			recentEntry: null,
			entries: null
		}
	},
	watch: {
		'$route'(to){
			this.slug = to.params.slug;
			this.getContent();
			this.recent();
		}
	},
	components: {
		VueMarkdown
		// MarkdownIt
	},
	methods: {
		recent() {
			let i = 0,
				count = true;
			for(i=0;i<this.entries.length; i++){
				if(this.$route.params.slug !== this.entries[i].slug && count){
					this.recentEntry = this.entries[i];
					count = false;
				}
			}
		},
		getContent() {
			axios.get("https://ango.waw.pl/markdowns/"+this.$route.params.slug+".md")
			.then(
				resp => {
					this.content = resp.data
					if(this.content.indexOf('<!DOCTYPE html>') > -1){
						this.$router.push('/')
					}
				}
			);
		},
		scrollToTop() {
			window.scrollTo(0,0);
		}
	},
	created() {
		axios.get("https://ango.waw.pl/markdowns/news.json")
			.then(
				resp => {
					this.entries = resp.data;
					
					this.recent();
				}
			)
		this.getContent();
	}
}
</script>

<style lang="scss" scoped>
	.news-bg{
		background-size: calc(100% - 30px) auto;
		background-position: top center;
		background-image: url('../assets/images/news-bg.jpg');
		background-repeat: no-repeat; 
	}
	.nav-row{
		position: relative;
		z-index: 2;
	}
	.content-row{
		position: relative;
		z-index: 1;
	}
</style>